<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <svg-policy-error-svg></svg-policy-error-svg>
    </div>
    <h1 class="title-copy">{{ 'BOP' | translate }}</h1> 
  </div>
</div>
<app-bop-screen></app-bop-screen>
<div class="text-center">
  <mapfre-button
    additionalClasses="link-button red-link small w-100 button-border-red"
    [backIcon]="'../../../../../assets/img/icons/back-arrow-red.png'"
    [iconClasses]="'align-middle'"
    (click)="goBackAPage()"
    [showIconsCustom]="true">  
    {{ 'BACK' | translate }}
  </mapfre-button>
</div>